import { Pages } from '@lib/types';
import { FlowType } from '@ace-clublabs/common-membership-api-types';

export interface PageNavigation {
  currentPage: Pages;
  nextPage?: Pages;
  overridePage?: Pages;
}

//Major rocket
const majorRocketPageNavigations: PageNavigation[] = [
  {
    currentPage: Pages.LandingPage,
    nextPage: Pages.BenefitsPage,
  },
  {
    currentPage: Pages.BenefitsPage,
    nextPage: Pages.ContactDetailsPage,
  },
  {
    currentPage: Pages.ContactDetailsPage,
    nextPage: Pages.AutoCompleteResidenceAddressPage,
  },
  {
    currentPage: Pages.AutoCompleteResidenceAddressPage,
    nextPage: Pages.BuildMembershipPage,
  },
  {
    currentPage: Pages.AutoCompleteMailingAddressPage,
    nextPage: Pages.BuildMembershipPage,
  },
  {
    currentPage: Pages.ResidenceAddressPage,
    nextPage: Pages.BuildMembershipPage,
  },
  {
    currentPage: Pages.MailingAddressPage,
    nextPage: Pages.BuildMembershipPage,
  },
  {
    currentPage: Pages.BuildMembershipPage,
    nextPage: Pages.ReviewPage,
  },
];

//T-mobile
const tMobilePageNavigations: PageNavigation[] = [
  {
    currentPage: Pages.LandingPage,
    nextPage: Pages.BenefitsPage,
  },
  {
    currentPage: Pages.BenefitsPage,
    nextPage: Pages.ContactDetailsPage,
  },
  {
    currentPage: Pages.ContactDetailsPage,
    nextPage: Pages.AutoCompleteResidenceAddressPage,
  },
  {
    currentPage: Pages.AutoCompleteResidenceAddressPage,
    nextPage: Pages.BuildMembershipPage,
  },
  {
    currentPage: Pages.AutoCompleteMailingAddressPage,
    nextPage: Pages.BuildMembershipPage,
  },
  {
    currentPage: Pages.ResidenceAddressPage,
    nextPage: Pages.BuildMembershipPage,
  },
  {
    currentPage: Pages.MailingAddressPage,
    nextPage: Pages.BuildMembershipPage,
  },
  {
    currentPage: Pages.BuildMembershipPage,
    nextPage: Pages.ReviewPage,
  },
];

//New Join
const newJoinPageNavigations: PageNavigation[] = [
  {
    currentPage: Pages.LandingPage,
    nextPage: Pages.BenefitsPage,
  },
  {
    currentPage: Pages.BenefitsPage,
    nextPage: Pages.ContactDetailsPage,
  },
  {
    currentPage: Pages.ContactDetailsPage,
    nextPage: Pages.AutoCompleteResidenceAddressPage,
  },
  {
    currentPage: Pages.AutoCompleteResidenceAddressPage,
    nextPage: Pages.BuildMembershipPage,
  },
  {
    currentPage: Pages.AutoCompleteMailingAddressPage,
    nextPage: Pages.BuildMembershipPage,
  },
  {
    currentPage: Pages.ResidenceAddressPage,
    nextPage: Pages.BuildMembershipPage,
  },
  {
    currentPage: Pages.MailingAddressPage,
    nextPage: Pages.BuildMembershipPage,
  },
  {
    currentPage: Pages.BuildMembershipPage,
    nextPage: Pages.ReviewPage,
  },
];

//Gift
const giftPageNavigations: PageNavigation[] = [
  {
    currentPage: Pages.LandingPage,
    nextPage: Pages.BenefitsPage,
  },
  {
    currentPage: Pages.BenefitsPage,
    nextPage: Pages.DateSelector,
  },
  {
    currentPage: Pages.DateSelector,
    nextPage: Pages.ContactDetailsPage,
  },
  {
    currentPage: Pages.ContactDetailsPage,
    nextPage: Pages.AutoCompleteResidenceAddressPage,
  },
  {
    currentPage: Pages.AutoCompleteResidenceAddressPage,
    nextPage: Pages.GiftDonorContactPage,
  },
  {
    currentPage: Pages.AutoCompleteMailingAddressPage,
    nextPage: Pages.GiftDonorContactPage,
  },
  {
    currentPage: Pages.ResidenceAddressPage,
    nextPage: Pages.GiftDonorContactPage,
  },
  {
    currentPage: Pages.MailingAddressPage,
    nextPage: Pages.GiftDonorContactPage,
  },
  {
    currentPage: Pages.GiftDonorContactPage,
    nextPage: Pages.GiftDonorAddressPage,
  },
  {
    currentPage: Pages.GiftDonorAddressPage,
    nextPage: Pages.SendMembershipCardPage,
  },
  {
    currentPage: Pages.SendMembershipCardPage,
    nextPage: Pages.SendGiftCardPage,
  },
  {
    currentPage: Pages.SendGiftCardPage,
    nextPage: Pages.BuildMembershipPage,
  },
  {
    currentPage: Pages.BuildMembershipPage,
    nextPage: Pages.ReviewPage,
  },
];

const navigations = {
  [FlowType.MAJOR_ROCKET]: majorRocketPageNavigations,
  [FlowType.B2B_MAJOR_ROCKET]: majorRocketPageNavigations,
  [FlowType.GROUPON]: newJoinPageNavigations,
  [FlowType.NEW_JOIN]: newJoinPageNavigations,
  [FlowType.EMPLOYEE]: newJoinPageNavigations,
  [FlowType.T_MOBILE]: tMobilePageNavigations,
  [FlowType.GIFT]: giftPageNavigations,
  [FlowType.REJOIN]: newJoinPageNavigations,
};

export const getNextPage = (
  currentPage: Pages,
  flowType: FlowType | undefined | null,
  override: boolean = false
): Pages => {
  let nextPage: Pages = Pages.SorryPage;

  if (!flowType) {
    return nextPage;
  }

  const navigation = navigations[flowType];

  const pageNavigation = navigation?.filter((i) => i.currentPage === currentPage)[0];

  if (pageNavigation == null || pageNavigation.nextPage == null || (override && pageNavigation.overridePage == null))
    return nextPage;

  if (override && pageNavigation.overridePage != null && pageNavigation.overridePage != undefined)
    nextPage = pageNavigation.overridePage;
  else nextPage = pageNavigation.nextPage;

  return nextPage;
};
